import styled from 'styled-components';

const FlexContainer = styled.div`
    display: flex;
`;

FlexContainer.displayName = 'FlexContainer';

export default FlexContainer;
